// extracted by mini-css-extract-plugin
export default {"container":"MoreAsset_container__3IDo3","header":"MoreAsset_header__75UxO","title":"MoreAsset_title__ZXfdE"};